import { primitiveAtomWithLS } from '@app/utils/reatom'

export const areOrderDetailsOpenedAtom = primitiveAtomWithLS<boolean>(
  true,
  'areOrderDetailsOpened',
)
